import { About_IMG, ChampionsForge_IMG, Contact_IMG, Home_IMG, OurServices_IMG, Programs_IMG } from '../Constants/ImageConstants';

export const SITE_NAME = 'Grassroots Sports Education & Services';
export const ORGANIZATION_NAME = 'Grassroots Sports Education & Services Pvt. Ltd.';
export const SITE_URL = 'https://www.grassrootssports.in';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/fev.png`;

type RobotsValue = 'index, follow' | 'noindex, follow' | 'noindex, nofollow';

type ImageMeta = {
  url: string;
  alt: string;
};

export type SeoConfig = {
  title: string;
  description: string;
  robots: RobotsValue;
  image?: ImageMeta;
  type?: 'website' | 'article';
  breadcrumbs?: Array<{ name: string; path: string }>;
  includeOrganization?: boolean;
  includeWebsite?: boolean;
  includeServiceData?: boolean;
};

export const ABSOLUTE_ADDRESS = {
  streetAddress: 'No 9/103, Mariappan Nagar, M. Perumapalayam, Valapady',
  addressLocality: 'Salem',
  addressRegion: 'Tamil Nadu',
  postalCode: '636111',
  addressCountry: 'IN',
};

export const seoByPath: Record<string, SeoConfig> = {
  '/': {
    title: 'Grassroots Sports Education & Services | Tamil Nadu',
    description:
      'Grassroots Sports Education & Services helps schools in Tamil Nadu build structured sports and physical education programs, coach education, and child-focused development pathways.',
    robots: 'index, follow',
    image: {
      url: Home_IMG.hero,
      alt: 'Students participating in a Grassroots Sports school program',
    },
    type: 'website',
    includeOrganization: true,
    includeWebsite: true,
  },
  '/about': {
    title: 'About Grassroots Sports Education & Services | Tamil Nadu Sports Education Team',
    description:
      'Learn how Grassroots Sports Education & Services supports schools, educators, and communities through child-centered sports and physical education in Tamil Nadu.',
    robots: 'index, follow',
    image: {
      url: About_IMG.aboutBanner,
      alt: 'Grassroots Sports Education & Services about page banner',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'About', path: '/about' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/contact': {
    title: 'Contact Grassroots Sports Education & Services | Salem, Tamil Nadu',
    description:
      'Contact Grassroots Sports Education & Services for school sports programs, coach education, consultations, and partnership enquiries in Tamil Nadu.',
    robots: 'index, follow',
    image: {
      url: Contact_IMG.contactBanner,
      alt: 'Contact Grassroots Sports Education & Services in Tamil Nadu',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Contact', path: '/contact' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/ourservices': {
    title: 'Sports Education & Sports Services in Tamil Nadu | Grassroots Sports Education & Services',
    description:
      'Explore in-school sports, coach education, recruitment, events, sports science, infrastructure, youth fitness, retail, and sponsorship services from Grassroots Sports Education & Services.',
    robots: 'index, follow',
    image: {
      url: OurServices_IMG.Baner_img,
      alt: 'Grassroots Sports Education & Services programs and services banner',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Our Services', path: '/ourservices' },
    ],
    includeOrganization: true,
    includeWebsite: true,
    includeServiceData: true,
  },
  '/championsforge': {
    title: 'ChampionsForge Youth Sports Stories & Updates | Grassroots Sports Education & Services',
    description:
      'Discover ChampionsForge, the storytelling and updates space from Grassroots Sports Education & Services featuring gallery highlights, youth sports stories, and program news.',
    robots: 'index, follow',
    image: {
      url: ChampionsForge_IMG.ChampionsForge2,
      alt: 'ChampionsForge youth sports storytelling and updates',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'ChampionsForge', path: '/championsforge' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/careers': {
    title: 'Sports Education Careers in Tamil Nadu | Grassroots Sports Education & Services',
    description:
      'Explore career opportunities with Grassroots Sports Education & Services and help shape sports, fitness, and physical education for schools and communities.',
    robots: 'index, follow',
    image: {
      url: About_IMG.aboutEnroll,
      alt: 'Careers with Grassroots Sports Education & Services',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Careers', path: '/careers' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/shop': {
    title: 'Sportswear & Equipment Retail | Grassroots Sports Education & Services',
    description:
      'Browse the Grassroots Sports Education & Services shop page for upcoming sportswear and equipment retail offerings for schools, academies, and teams.',
    robots: 'index, follow',
    image: {
      url: Programs_IMG.kidsnadults_3Image,
      alt: 'Sportswear and equipment retail from Grassroots Sports Education & Services',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Shop', path: '/shop' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/coming-soon': {
    title: 'Coming Soon | Grassroots Sports Education & Services',
    description:
      'This section of Grassroots Sports Education & Services is being prepared and will be available soon.',
    robots: 'noindex, follow',
    image: {
      url: `${SITE_URL}/fev.png`,
      alt: 'Grassroots Sports Education & Services coming soon page',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Coming Soon', path: '/coming-soon' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '/signin': {
    title: 'Sign In | Grassroots Sports Education & Services',
    description:
      'Sign in to access Grassroots Sports Education & Services resources and account features.',
    robots: 'noindex, nofollow',
    image: {
      url: `${SITE_URL}/fev.png`,
      alt: 'Grassroots Sports Education & Services sign in',
    },
    breadcrumbs: [
      { name: 'Home', path: '/' },
      { name: 'Sign In', path: '/signin' },
    ],
    includeOrganization: true,
    includeWebsite: true,
  },
  '*': {
    title: 'Page Not Found | Grassroots Sports Education & Services',
    description:
      'The requested page could not be found on the Grassroots Sports Education & Services website.',
    robots: 'noindex, nofollow',
    image: {
      url: `${SITE_URL}/fev.png`,
      alt: 'Grassroots Sports Education & Services page not found',
    },
    includeOrganization: true,
    includeWebsite: true,
  },
};

export const serviceCatalog = [
  {
    name: 'In-School Sports & Physical Education Programs',
    description:
      'Structured curriculum-aligned sports and physical education programs for KG to Grade 12 with multimedia learning and qualified sports educators.',
    url: `${SITE_URL}/ourservices#in-school-sports`,
  },
  {
    name: 'Grassroots Sports Coach Education',
    description:
      'Coach education programs for physical education teachers, coaches, and sports professionals with child-centered coaching and sports science foundations.',
    url: `${SITE_URL}/ourservices#coach-education`,
  },
  {
    name: 'Sports Professional Recruitment & HR Services',
    description:
      'Recruitment, training, and deployment support for coaches, PE teachers, sports scientists, and sports program staff.',
    url: `${SITE_URL}/ourservices#recruitment-hr`,
  },
  {
    name: 'Sports Events & Tournament Management',
    description:
      'Planning, branding, logistics, officiating, and event operations for school, academy, corporate, and community sports events.',
    url: `${SITE_URL}/ourservices#events-management`,
  },
  {
    name: 'Sports Science Consultation Services',
    description:
      'Evidence-based consultation in physiotherapy, psychology, strength and conditioning, nutrition, biomechanics, and athlete monitoring.',
    url: `${SITE_URL}/ourservices#sports-science`,
  },
  {
    name: 'Sports Infrastructure Consultation Services',
    description:
      'End-to-end consultation for sports facility planning, design, equipment, safety, and long-term sports infrastructure development.',
    url: `${SITE_URL}/ourservices#infrastructure`,
  },
  {
    name: 'Youth Fitness & Conditioning Programs',
    description:
      'Safe, age-appropriate youth fitness and conditioning programs that support movement quality, strength, agility, and long-term athlete development.',
    url: `${SITE_URL}/ourservices#youth-fitness`,
  },
  {
    name: 'Sportswear & Equipment Retail',
    description:
      'Sportswear, uniforms, training equipment, and accessories for schools, academies, teams, and sports organizations.',
    url: `${SITE_URL}/ourservices#sportswear-retail`,
  },
  {
    name: 'Sports Branding & Sponsorship Solutions',
    description:
      'Branding, sponsorship strategy, promotions, partnership development, and marketing support for sports organizations and events.',
    url: `${SITE_URL}/ourservices#branding-sponsorship`,
  },
];
